export const widgetName: string = 'cards-wall';
export const widgetDisplayName: string = 'Cards wall';
export const widgetCategory: string = 'Reply.com';
export const widgetSelector: string = 'cards-wall';
export const widgetEditorSelector: string = 'cards-wall-editor';
export const widgetRuntimeSelector: string = 'cards-wall-runtime';
export const containerClassName: string = 'cards-wall-grid-container';
export const bindingContextClassName: string = 'cards-wall-binding';
export const implictReferenceCMSContentType: string = 'article';
export const defaultContentTypesId: string[] = ['article', 'news', 'event', 'website'];

export const defaultFiltersType: 'newsroom' = 'newsroom' as const;
export const defaultItemsOffset: number = 0;
export const defaultItemsLimit: number = 4;
export const defaultOrderingField: string = 'sortDate';
export const defaultFilteringDateField: string = 'sortDate';
export const defaultOrderingType: string = 'desc';
export const defaultStaticMultiplier: number = 1;
export const featuredCardLayout: string = 'card-hero-default';
export const featuredContentsMultiplier: number = 4 * 2;